<template>
  <div class="kfqg">
    <div class="kfqg-title">
      <div>台湾问题研究网</div>
      <p>实时资讯，统计数据，资料信息，文献报告</p>
    </div>
    <div class="kfqg-content">
      <p class="content-title">
        海外事实型数据库，数据每日更新，内容丰满鲜活。其主旨在为希望了解台湾或从事台湾研究人员提供台湾地区媒体及官方机构，关于台湾地区经贸、社会等方面信息及数据的汇集。截止目前，台研网已经收录相关资料120余万篇。
      </p>
      <div class="content-wrap">
        <img class="wrap-img" src="@/assets/image/gw_twwt.png" />
        <div class="wrap-info">
          <div class="info-item">
            <div class="item-til">
              <div></div>
              大数据积累
            </div>
            <p class="item-ind">
              拥有自2014年起的逾3万篇各类文献，最早可回溯至1997年的187本统计资料，近8万张表格，1500余万个统计数据，是目前市场上内容最丰富的京津冀协同发展综合信息平台。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              广覆盖面
            </div>
            <p class="item-ind">
              汇集台湾各阵营超过80个媒体有关台湾地区财经信息、宏观经济、贸易投资、财税金融、时政要闻、最新调查、产业动态等领域的所有报道全文。以及台湾当局及各级政府部门官网。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              原貌展示
            </div>
            <p class="item-ind">
              本站所有信息均采自台湾地区的公开“媒体”及“台湾各地官方机构或企业官方网站”，文字内容保持与台湾地区“来源”一致，未作“编辑调整”。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              简体化阅读
            </div>
            <p class="item-ind">
              虽然目前台湾所有相关内容均以繁体字作为主要的刊载字体，收录入库均对其以中国大陆通用的简体字进行收录，以便阅读。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              特色关联
            </div>
            <p class="item-ind">
              既有各类媒体和专家学者的建言建议、评论分析，也有京津冀协同发展所涉及的各领域专业研究论文、报告，还有公司自己的年度报告，提供更深层次的文献数据，更高的参考价值。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.kfqg-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_taiwan.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.kfqg-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    .wrap-img {
      max-width: 50%;
    }
    .wrap-info {
      width: 45%;
      .info-item {
        padding: 24px 40px;
        margin: 32px 0;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 0px 16px 0px #cfd8eb;
        .item-til {
          position: relative;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          div {
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 50px;
            height: 20px;
            opacity: 0.3;
            background: #0377ff;
            border-radius: 10px;
          }
        }
        .item-ind {
          margin: 24px 0;
          font-size: 16px;
          font-weight: 400;
          color: #656565;
        }
      }
    }
  }
}
</style>
